export function left(amount: number, total: number) {
    const value = amount === total
        ? amount
        : `${amount} (${total})`;

    return `${value} item(s)`;
}